import { useContext } from "react";
import { WrapperRoutersContext } from "../contexts/wrapperRoutersContext";

export const useWrapperRouters = () => {
  const context = useContext(WrapperRoutersContext);

  return context;
};
